import styled from 'styled-components';
import { vw } from 'components/common/Common';
import Introduce from './Introduce';
import WhyFly from './WhyFly';
import Cards from './Cards';
import WhyChoose from './WhyChoose';
import FeatureGrid from './FeatureGrid';
import IconFeatureBlocks from './IconFeatureBlocks';
import ImgDescCard from 'components/ImgDescCard';
import Flight from './Flight';
import FAQAccordion from 'pages/charterQuote/components/contents/FAQAccordion';

import ContactInfo from './ContactInfo';

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 ${vw(50)} ${vw(100)} ${vw(50)};
  display: flex;
  flex-direction: column;
  gap: ${vw(145)};
  align-items: center;
`;

const LargeAircraft = styled.img`
  width: 100vw;
  object-fit: cover;
  margin: 20px 0;
`;

const Desc = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: #424748;
  line-height: 1.3;
`;

const QuestionLists = [
  {
    question: 'Do my Jet Card hours expire?',
    answer:
      'Our Jet Card hours come with a generous two-year validity period, allowing you ample time to utilize your flight hours at your convenience.',
  },
  {
    question: 'Is in-flight Wi-Fi available on all private jet charters?',
    answer:
      'We provide in-flight Wi-Fi on all our private jet charters, allowing you to remain productive and entertained while airborne.',
  },
  {
    question: 'Can I upgrade or downgrade my aircraft size without penalties?',
    answer:
      'Absolutely. Our program offers the flexibility to upgrade or downgrade your aircraft size as needed, without any penalties.',
  },
];

const Content = () => {
  return (
    <Container>
      <LargeAircraft
        src="/imgs/webp/jetCard/charter.webp"
        alt="Private jet charter service for business and leisure"
      />
      <WhyFly />
      <Cards />
      <Introduce />
      <WhyChoose />

      <LargeAircraft
        src="/imgs/webp/jetCard/luxury.webp"
        alt="Luxury ground transfer service waiting by a private jet"
      />

      <FeatureGrid />

      <LargeAircraft
        src="/imgs/webp/jetCard/personalized.webp"
        alt="Personalized catering service on a private jet"
      />

      <IconFeatureBlocks />

      <ImgDescCard
        isLeft={false}
        imgSrc="/imgs/webp/home/book.webp"
        imgAlt="a luxury private jet at sunrise"
        title="Our Commitment to Safety"
        flipImg={true}
      >
        <Desc>
          We care about your safety and peace of mind while flying. All crews follow strict
          protocols to ensure every flight is secure before takeoff.
        </Desc>
        <Desc>
          We also partner with fully vetted operators to guarantee your flights meet the highest
          standards in safety, reliability, and professionalism. You can relax and have confidence
          in our pre-flight safety checks, up-to-date maintenance records, thorough pilot and crew
          vetting, and updated safety and insurance policies.
        </Desc>
      </ImgDescCard>

      <ImgDescCard
        isLeft
        imgSrc="/imgs/webp/jetCard/hangar.webp"
        imgAlt="close up of private jet aircrafts outside of hangar"
        title="Jet Cards Backed by Experience"
      >
        <Desc>
          With 11,000+ satisfied flyers, no one understands personalized, private aviation quite
          like Airacer. Our jet card programs and 10+ years of industry experience bring you the
          booking flexibility and tranquil privacy that first-class flying simply can’t offer.
        </Desc>
        <Desc>
          Have an upcoming trip? Your jet card membership comes with a dedicated personal flight
          manager to assist with airport chauffeur services, special dietary needs, pet-friendly
          flying, and other ways to make your journey seamless and comfortable.
        </Desc>
      </ImgDescCard>

      <Flight />

      <ImgDescCard
        isLeft={false}
        imgSrc="/imgs/webp/charterQuote/questions.webp"
        imgAlt="private jet preparing for takeoff on the tarmac"
        title="Airacer Jet Card Program FAQs"
        desc={['Answers to common inquiries regarding our Jet Card Program services.']}
      >
        <FAQAccordion QuestionLists={QuestionLists} />
      </ImgDescCard>

      <ContactInfo />
    </Container>
  );
};

export default Content;
